(() => {
  const syncStickyPurchase = (root) => {
    const sectionId = root.dataset.sectionId;
    const productInfo = document.getElementById(`MainProduct-${sectionId}`);
    const canonicalButton = document.getElementById(`ProductSubmitButton-${sectionId}`);
    const canonicalPrice = document.getElementById(`price-${sectionId}`);
    const stickyPrice = root.querySelector('[data-k-sticky-price]');
    const stickyButton = root.querySelector('[data-k-sticky-submit]');

    if (!productInfo || !canonicalButton || !stickyButton) return;

    const update = () => {
      const visiblePrice = canonicalPrice?.querySelector('.price-item--regular, .price-item--sale')?.textContent?.trim();
      const canonicalLabel = canonicalButton.querySelector('span')?.textContent?.trim();
      if (visiblePrice && stickyPrice && stickyPrice.textContent !== visiblePrice) stickyPrice.textContent = visiblePrice;
      if (canonicalLabel && stickyButton.textContent.trim() !== canonicalLabel) stickyButton.textContent = canonicalLabel;
      if (stickyButton.disabled !== canonicalButton.disabled) stickyButton.disabled = canonicalButton.disabled;
    };

    stickyButton.addEventListener('click', () => canonicalButton.click());
    if (canonicalPrice) {
      new MutationObserver(update).observe(canonicalPrice, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    }
    new MutationObserver(update).observe(canonicalButton, {
      attributes: true,
      attributeFilter: ['disabled'],
      childList: true,
      subtree: true,
      characterData: true,
    });

    root.hidden = false;
    update();
  };

  const chooseSingleJarOffer = (productInfo) => {
    let checks = 0;
    let customerChangedOffer = false;

    const normalizeOfferCopy = () => {
      const title = productInfo.querySelector('.Avada-Volume__HeaderTitle-Text');
      const group = productInfo.querySelector('.Avada-VolumeItem__Container');
      const locale = document.documentElement.lang?.slice(0, 2) || 'sl';
      const recommendedLabel = locale === 'de' ? 'Empfohlen' : locale === 'en' ? 'Recommended' : 'Priporočena izbira';

      if (title?.textContent.trim() === 'Kupi več, in privarčuj') {
        title.textContent = 'Kupi več in privarčuj';
      }
      if (group?.getAttribute('aria-label') === 'Kupi več, in privarčuj') {
        group.setAttribute('aria-label', 'Kupi več in privarčuj');
      }

      productInfo.querySelectorAll('.Avada-BadgeText').forEach((badge) => {
        if (/najbolj\s*prodajano|best\s*seller|bestseller/i.test(badge.textContent)) {
          badge.textContent = recommendedLabel;
        }
      });
    };

    const labelTextFor = (input) => {
      if (input.matches('[role="radio"]')) return input.textContent.replace(/\s+/g, ' ').trim();
      const label = input.id ? productInfo.querySelector(`label[for="${CSS.escape(input.id)}"]`) : null;
      return `${label?.textContent || ''} ${input.getAttribute('aria-label') || ''}`
        .replace(/\s+/g, ' ')
        .trim();
    };

    const markCustomerChoice = (event) => {
      if (
        event.isTrusted &&
        event.target instanceof Element &&
        event.target.closest('[role="radiogroup"], input[type="radio"]')
      ) {
        customerChangedOffer = true;
      }
    };

    productInfo.addEventListener('pointerdown', markCustomerChoice, { passive: true });
    productInfo.addEventListener('change', markCustomerChoice);

    const selectionTimer = window.setInterval(() => {
      checks += 1;
      normalizeOfferCopy();
      if (customerChangedOffer || checks >= 24) {
        window.clearInterval(selectionTimer);
        return;
      }

      const singleJar = [...productInfo.querySelectorAll('input[type="radio"], [role="radio"]')].find((input) =>
        /kupi\s*1|buy\s*1|kauf(?:e)?\s*1|1\s*(kozarec|jar|glas)/i.test(labelTextFor(input))
      );

      if (!singleJar) return;

      const isSelected = singleJar.checked || singleJar.getAttribute('aria-checked') === 'true';
      if (isSelected) return;

      singleJar.click();
    }, 350);
  };

  const initPurchaseSelection = (productInfo) => {
    const selectionSummary = productInfo.querySelector('[data-k-selection-summary]');
    const sectionId = productInfo.id.replace(/^MainProduct-/, '');
    const stickyPurchase = document.querySelector(
      `[data-k-sticky-purchase][data-section-id="${CSS.escape(sectionId)}"]`
    );
    if (!selectionSummary && !stickyPurchase) return;

    const locale = document.documentElement.lang?.slice(0, 2) || 'sl';
    const singleLabel = locale === 'de' ? '1 Glas' : locale === 'en' ? 'Buy 1' : '1 kozarec';
    let scheduled = false;

    const normalizeSize = (value = '') =>
      value
        .replace(/\s+/g, ' ')
        .replace(/(250|125|60)\s*g\b/i, '$1 g')
        .trim();

    const formatEuro = (value) =>
      new Intl.NumberFormat(locale === 'sl' ? 'sl-SI' : locale === 'de' ? 'de-DE' : 'en-IE', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(value);

    const localizeEuroText = (text) =>
      text
        .replace(/€\s*(\d+(?:[.,]\d{1,2})?)/g, (_match, amount) =>
          formatEuro(Number.parseFloat(amount.replace(',', '.')))
        )
        .replace(/(\d+(?:[.,]\d{1,2})?)\s*€/g, (_match, amount) =>
          formatEuro(Number.parseFloat(amount.replace(',', '.')))
        );

    const localizeOfferPrices = () => {
      const offer = productInfo.querySelector('.Avada-Bundle-Volume__Container');
      if (!offer || locale === 'en') return;

      const walker = document.createTreeWalker(offer, NodeFilter.SHOW_TEXT);
      const textNodes = [];
      while (walker.nextNode()) textNodes.push(walker.currentNode);
      textNodes.forEach((node) => {
        if (!node.textContent?.includes('€')) return;
        const localized = localizeEuroText(node.textContent);
        if (localized !== node.textContent) node.textContent = localized;
      });
    };

    const selectedSize = () => {
      const checkedOptions = [...productInfo.querySelectorAll('.product-form__input input[type="radio"]:checked')];
      const checked = checkedOptions[checkedOptions.length - 1];
      if (checked) {
        return normalizeSize(checked.value);
      }

      const selectedOptions = [...productInfo.querySelectorAll('.product-form__input select')]
        .map((select) => select.selectedOptions?.[0]?.textContent)
        .filter(Boolean);
      const selected = selectedOptions[selectedOptions.length - 1];
      return normalizeSize(selected || '');
    };

    const selectedOffer = () => {
      const explicit = productInfo.querySelector(
        '.Avada-Volume__Item--Selected, .Avada-Volume__Item[aria-checked="true"]'
      );
      if (explicit) return explicit;
      return [...productInfo.querySelectorAll('.Avada-ItemTier')].find((item) =>
        item.querySelector('.Avada-ItemRadioBtn.-selected')
      );
    };

    const offerLabel = (offer) => {
      if (!offer) return singleLabel;
      const explicit = offer.querySelector('.Avada-Volume__Info--TriggerQty > span:first-child')?.textContent;
      const text = (explicit || offer.textContent || '').replace(/\s+/g, ' ').trim();
      const quantity = text.match(/(?:kupi|buy|kaufe?|kauf)\s*(\d+)/i)?.[1] || text.match(/^\s*(\d+)\b/)?.[1];
      if (!quantity || quantity === '1') return singleLabel;
      if (locale === 'de') return `${quantity} Gläser`;
      if (locale === 'en') return `Buy ${quantity}`;
      return quantity === '2' ? '2 kozarca' : `${quantity} kozarci`;
    };

    const visiblePrice = (offer) => {
      const offerPrice = offer?.querySelector('.AOV-Offer__DiscountPrice')?.textContent?.trim();
      if (offerPrice) return localizeEuroText(offerPrice);
      const canonicalPrice = productInfo
        .querySelector('[id^="price-"] .price-item--sale, [id^="price-"] .price-item--regular')
        ?.textContent?.trim();
      return canonicalPrice ? localizeEuroText(canonicalPrice) : '';
    };

    const setText = (element, value) => {
      if (element && value && element.textContent !== value) element.textContent = value;
    };

    const update = () => {
      scheduled = false;
      localizeOfferPrices();

      const offer = selectedOffer();
      const pack = offerLabel(offer);
      const size = selectedSize();
      const price = visiblePrice(offer);
      const choice = [pack, size].filter(Boolean).join(' · ');

      setText(selectionSummary?.querySelector('[data-k-selection-choice]'), choice);
      setText(selectionSummary?.querySelector('[data-k-selection-price]'), price);
      setText(stickyPurchase?.querySelector('[data-k-sticky-pack]'), pack);
      setText(stickyPurchase?.querySelector('[data-k-sticky-selection]'), size || pack);
      setText(stickyPurchase?.querySelector('[data-k-sticky-price]'), price);
    };

    const scheduleUpdate = () => {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(update);
    };

    productInfo.addEventListener('change', scheduleUpdate);
    productInfo.addEventListener('click', scheduleUpdate);
    new MutationObserver(scheduleUpdate).observe(productInfo, {
      attributes: true,
      attributeFilter: ['class', 'aria-checked'],
      childList: true,
      subtree: true,
      characterData: true,
    });

    scheduleUpdate();
  };

  const initCinematicLayer = () => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.documentElement.classList.add('k-cine-armed');

    const revealTargets = new Set(document.querySelectorAll('[data-k-cine]'));
    document
      .querySelectorAll('.k-need-index__media img, .k-bundles__media img, .k-product-journal__ingredient-grid img, .k-product-story__visual-grid img')
      .forEach((media) => {
        media.classList.add('k-develop', 'k-develop--blur');
        revealTargets.add(media);
      });
    document
      .querySelectorAll(
        '.k-cold-process__media img, .k-manifesto__image img, .k-process-story__visual img, .k-product-journal__feature img, .k-product-story__feature img, .k-origin-journal__media img, .k-origin-journal__media video'
      )
      .forEach((media) => {
        media.classList.add('k-develop');
        revealTargets.add(media);
      });

    if (!('IntersectionObserver' in window)) {
      revealTargets.forEach((el) => el.classList.add('is-inview'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries, self) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-inview');
          self.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -6% 0px', threshold: 0.06 }
    );

    revealTargets.forEach((el) => observer.observe(el));
  };

  const initOriginVideo = () => {
    document.querySelectorAll('.k-origin-journal__video').forEach((video) => {
      video.defaultMuted = true;
      video.muted = true;

      const play = () => {
        const playback = video.play();
        if (playback) playback.catch(() => {});
      };

      video.addEventListener('canplay', play, { once: true });

      if (!('IntersectionObserver' in window)) {
        play();
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) play();
            else video.pause();
          });
        },
        { threshold: 0.12 }
      );

      observer.observe(video);
    });
  };

  const initProcessStory = () => {
    document.querySelectorAll('[data-k-story]').forEach((story) => {
      if (story.dataset.kStoryReady === 'true') return;
      story.dataset.kStoryReady = 'true';

      const steps = [...story.querySelectorAll('[data-story-step]')];
      if (!steps.length) return;

      const sticky = story.querySelector('.k-process-story__sticky');
      const canvas = story.querySelector('.k-process-story__canvas');
      const figures = [...story.querySelectorAll('[data-story-figure]')];
      const progressItems = [...story.querySelectorAll('[data-story-progress-item]')];
      const jumps = [...story.querySelectorAll('[data-story-jump]')];
      const count = story.querySelector('[data-story-count]');
      const ghost = story.querySelector('[data-story-ghost]');
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const total = steps.length;

      progressItems.forEach((item, index) => {
        const image = figures[index]?.querySelector('img');
        const source = image?.currentSrc || image?.src;
        if (source) item.style.setProperty('--k-progress-image', `url("${source.replaceAll('"', '%22')}")`);
      });

      let current = -1;
      let leavingTimer;
      const setActive = (index) => {
        const next = Math.max(0, Math.min(total - 1, index));
        if (next === current) return;

        const outgoing = figures[current];
        const incoming = figures[next];
        window.clearTimeout(leavingTimer);
        figures.forEach((figure) => figure.classList.remove('is-leaving'));

        if (outgoing && outgoing !== incoming && !reduceMotion) {
          outgoing.classList.remove('is-visible');
          outgoing.classList.add('is-leaving');
          leavingTimer = window.setTimeout(() => outgoing.classList.remove('is-leaving'), 850);
        } else if (outgoing) {
          outgoing.classList.remove('is-visible', 'is-leaving');
        }

        incoming?.classList.remove('is-leaving');
        incoming?.classList.add('is-visible');
        current = next;
        story.dataset.activeStep = String(next);
        story.style.setProperty('--k-story-progress', `${((next + 0.5) / total) * 100}%`);

        steps.forEach((step, i) => step.classList.toggle('is-active', i === next));
        progressItems.forEach((item, i) => {
          item.classList.toggle('is-active', i === next);
          item.classList.toggle('is-complete', i < next);
          const button = item.querySelector('[data-story-jump]');
          if (i === next) button?.setAttribute('aria-current', 'step');
          else button?.removeAttribute('aria-current');
        });

        const visibleNumber = String(next + 1).padStart(2, '0');
        const totalNumber = String(total).padStart(2, '0');
        if (count) count.textContent = `${visibleNumber} / ${totalNumber}`;
        if (ghost) ghost.textContent = visibleNumber;
      };

      const pickStep = () => {
        ticking = false;
        const stickyRect = sticky?.getBoundingClientRect();
        const mobileAnchor = stickyRect
          ? stickyRect.bottom + Math.max(0, window.innerHeight - stickyRect.bottom) * 0.48
          : window.innerHeight * 0.76;
        const canvasRect = canvas?.getBoundingClientRect();
        const desktopAnchor = canvasRect ? (canvasRect.top + canvasRect.bottom) / 2 : window.innerHeight * 0.58;
        const mid = window.innerWidth < 990 ? Math.min(window.innerHeight * 0.84, mobileAnchor) : desktopAnchor;
        let best = 0;
        let bestDist = Infinity;
        steps.forEach((step, i) => {
          const rect = step.getBoundingClientRect();
          const dist = Math.abs(rect.top + rect.height / 2 - mid);
          if (dist < bestDist) {
            bestDist = dist;
            best = i;
          }
        });
        setActive(best);
      };

      let ticking = false;
      const onScroll = () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(pickStep);
      };

      setActive(0);
      pickStep();

      jumps.forEach((button) => {
        button.addEventListener('click', () => {
          const index = Number(button.dataset.stepIndex);
          const step = steps[index];
          if (!step) return;

          if (window.innerWidth < 990 && sticky) {
            const stickyHeight = sticky.getBoundingClientRect().height;
            const offset = Math.min(window.innerHeight * 0.66, stickyHeight + 76);
            const top = window.scrollY + step.getBoundingClientRect().top - offset;
            window.scrollTo({ top, behavior: reduceMotion ? 'auto' : 'smooth' });
          } else {
            step.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
          }
        });
      });

      if (!('IntersectionObserver' in window)) {
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll, { passive: true });
        return;
      }

      const gate = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              window.addEventListener('scroll', onScroll, { passive: true });
              window.addEventListener('resize', onScroll, { passive: true });
              onScroll();
            } else {
              window.removeEventListener('scroll', onScroll);
              window.removeEventListener('resize', onScroll);
            }
          });
        },
        { rootMargin: '25% 0px 25% 0px' }
      );

      gate.observe(story);
    });
  };

  const initConversionSignals = () => {
    const context = {
      locale: document.documentElement.lang?.slice(0, 2) || 'sl',
      device: window.matchMedia('(max-width: 749px)').matches ? 'mobile' : 'desktop',
    };
    const emit = (name, detail = {}) => {
      const payload = { event: `kosale_${name}`, ...context, ...detail };
      window.dispatchEvent(new CustomEvent('kosale:conversion', { detail: payload }));
      if (Array.isArray(window.dataLayer)) window.dataLayer.push(payload);
    };

    const productInfo = document.querySelector('.k-field-notes-product');
    if (productInfo) {
      const productTitle = productInfo.querySelector('.product__title')?.textContent?.replace(/\s+/g, ' ').trim();
      const productHandle = location.pathname.split('/products/')[1]?.split(/[/?#]/)[0] || '';
      const selectedVariant = () => productInfo.querySelector('form[action*="/cart/add"] input[name="id"]')?.value || '';

      emit('product_view', { product_handle: productHandle, product_title: productTitle });

      productInfo.addEventListener('change', (event) => {
        const control = event.target;
        if (!(control instanceof HTMLInputElement || control instanceof HTMLSelectElement)) return;
        if (control.closest('.Avada-VolumeItem__Container')) {
          emit('tier_selection', {
            product_handle: productHandle,
            selection: control.getAttribute('aria-label') || control.value || control.textContent?.trim(),
          });
          return;
        }
        if (control.closest('variant-selects, variant-radios, .product-form__input')) {
          emit('size_selection', {
            product_handle: productHandle,
            option_name: control.name,
            option_value: control.value,
            variant_id: selectedVariant(),
          });
        }
      });

      productInfo.querySelector('[id^="ProductSubmitButton-"]')?.addEventListener('click', () => {
        emit('add_to_cart', { product_handle: productHandle, variant_id: selectedVariant() });
      });
    }

    if (document.body.classList.contains('template-cart')) {
      const cartTotal = document.querySelector('.totals__total-value')?.textContent?.replace(/\s+/g, ' ').trim();
      emit('cart_view', { cart_total: cartTotal });
      document.addEventListener('click', (event) => {
        const checkout = event.target instanceof Element ? event.target.closest('[name="checkout"]') : null;
        if (checkout) emit('checkout_started', { cart_total: cartTotal });
      });
    }
  };


  const initAovVolumeDiscountFallback = () => {
    const offerId = 'itsaK4ZE5Khspu459kkz';
    const propertyName = 'properties[_aov_bundles]';
    const propertyKey = '_aov_bundles';
    const propertyValue = JSON.stringify({ offerId });

    const tagProductForm = (form) => {
      if (!(form instanceof HTMLFormElement) || !form.matches('form[action*="/cart/add"]')) return;

      let field = [...form.elements].find((element) => element.name === propertyName);
      if (!field) {
        field = document.createElement('input');
        field.type = 'hidden';
        field.name = propertyName;
        form.appendChild(field);
      }
      field.value = propertyValue;
    };

    const tagProductForms = (root = document) => {
      if (root instanceof HTMLFormElement) tagProductForm(root);
      root.querySelectorAll?.('form[action*="/cart/add"]').forEach(tagProductForm);
    };

    tagProductForms();

    document.addEventListener(
      'submit',
      (event) => {
        if (event.target instanceof HTMLFormElement) tagProductForm(event.target);
      },
      true
    );

    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node instanceof Element) tagProductForms(node);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });

    if (!document.body.classList.contains('template-cart')) return;

    const repairExistingCart = async () => {
      try {
        const root = window.Shopify?.routes?.root || '/';
        const cart = await fetch(root + 'cart.js', {
          headers: { Accept: 'application/json' },
          credentials: 'same-origin',
        }).then((response) => {
          if (!response.ok) throw new Error('Unable to read cart');
          return response.json();
        });

        const missing = cart.items.filter((item) => !item.properties?.[propertyKey]);
        if (!missing.length) {
          sessionStorage.removeItem('kosale:aov-cart-repair');
          return;
        }

        const repairKey = cart.token + ':' + missing.map((item) => item.key + ':' + item.quantity).join('|');
        if (sessionStorage.getItem('kosale:aov-cart-repair') === repairKey) return;
        sessionStorage.setItem('kosale:aov-cart-repair', repairKey);

        for (const item of missing) {
          const properties = { ...(item.properties || {}), [propertyKey]: propertyValue };
          const response = await fetch(root + 'cart/change.js', {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
            credentials: 'same-origin',
            body: JSON.stringify({
              id: item.key,
              quantity: item.quantity,
              properties,
            }),
          });
          if (!response.ok) throw new Error('Unable to update cart item');
        }

        window.location.reload();
      } catch (error) {
        console.warn('Košale: automatic volume discount metadata could not be refreshed.', error);
      }
    };

    repairExistingCart();
  };

  const init = () => {
    document.querySelectorAll('[data-k-sticky-purchase]').forEach(syncStickyPurchase);
    document.querySelectorAll('.k-field-notes-product').forEach(chooseSingleJarOffer);
    document.querySelectorAll('.k-field-notes-product').forEach(initPurchaseSelection);
    initCinematicLayer();
    initOriginVideo();
    initProcessStory();
    initConversionSignals();
    initAovVolumeDiscountFallback();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
